import React from 'react'
import { CloseIcon } from '@components/Icons'
import { ActivityIndicator, Image, Pressable, StyleSheet, View } from 'react-native'
import Show from '@components/Show'
import { colors } from '@lib/colors'

interface ImageThumbnailProps {
  photo: Photo
  onPress: () => void
  onDelete: () => void
  isDeleting: boolean
}

export default function ({ photo, isDeleting, onPress, onDelete }: ImageThumbnailProps) {

  const onThumbnailPress = () => {
    if (!photo?.fileURL) return
    onPress()
  }

  return (
    <View style={styles.wrapper}>
      <Pressable onPress={onThumbnailPress} style={styles.wrapper}>
        <Image
          source={{ uri: photo?.uri }}
          style={
            (photo?.fileURL && !isDeleting)
              ? styles.photo
              : styles.photoLoading
          }
          />
        <Show when={!photo?.fileURL || isDeleting}>
          <View style={styles.activityIndicatorWrapper}>
            <ActivityIndicator color={colors.black} />
          </View>
        </Show>
      </Pressable>
      <Show when={photo?.fileURL && !isDeleting}>
        <Pressable style={styles.deleteButtonBorder} onPress={onDelete}>
          <View style={styles.deleteButton}>
            <CloseIcon size={18} color={colors.white} />
          </View>
        </Pressable>
      </Show>
    </View>
  )
}

const styles = StyleSheet.create({
  activityIndicatorWrapper: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    marginRight: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  photo: {
    height: '100%',
    width: 100,
    marginRight: 10,
    borderRadius: 3,
  },
  photoLoading: {
    height: '100%',
    width: 100,
    marginRight: 10,
    borderRadius: 3,
    opacity: 0.3,
  },
  wrapper: {
    position: 'relative',
    height: '100%',
  },
  deleteButtonBorder: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    top: 2,
    right: 12,
    width: 24,
    height: 24,
    backgroundColor: colors.gray[100],
    borderRadius: 16,
  },
  deleteButton: {
    backgroundColor: colors.tertiary,
    borderRadius: 16,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
